module.exports = __webpack_public_path__ + "static/media/softwareDevelopmentImgMobile.fc39ebc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/softwareDevelopmentImgMobile.jpg
// module id = 860
// module chunks = 6